import React from 'react';
import { Flipped } from 'react-flip-toolkit';

import { expValEquals } from '@confluence/feature-experiments';

const animations = {
	slideInFromTop: (element: HTMLElement, duration = 300) => {
		element.style.transform = 'translateY(-20px)';
		element.style.opacity = '0';

		return element.animate(
			[
				{ transform: 'translateY(-20px)', opacity: 0 },
				{ transform: 'translateY(0)', opacity: 1 },
			],
			{ duration, easing: 'cubic-bezier(.2, 0, 0, 1)', fill: 'forwards' },
		);
	},

	slideOutToBottom: (element: HTMLElement, duration = 250) => {
		return element.animate(
			[
				{ transform: 'translateY(0)', opacity: 1 },
				{ transform: 'translateY(20px)', opacity: 0 },
			],
			{ duration, easing: 'ease-in' },
		);
	},
};

export const FlippedAnimationsWrapper = ({
	children,
	flipId,
}: {
	children: React.ReactNode;
	flipId: string | number;
}) => {
	const onTileAppear = (element: HTMLElement) => {
		const animation = animations.slideInFromTop(element, 400);
		const onFinish = () => {
			element.style.transform = '';
			element.style.opacity = '';
			animation.removeEventListener('finish', onFinish);
		};
		animation.addEventListener('finish', onFinish);
	};

	const onTileExit = (element: HTMLElement, _: number, removeElement: () => void) => {
		animations.slideOutToBottom(element).addEventListener('finish', removeElement);
	};
	if (expValEquals('cc-motion-survey-experiment', 'cohort', 'experiment')) {
		return (
			<Flipped flipId={flipId} stagger onAppear={onTileAppear} onExit={onTileExit}>
				<div>{children}</div>
			</Flipped>
		);
	}
	return <>{children}</>;
};
